<template>
    <HeroBlockSection v-if="content && content.hero" :content="content.hero" />
    <div class="page__container">
      <ServicesSection v-if="content && content.services" :content="content.services" />
      <AboutSection v-if="content && content.about" :content="content.about"/>
      <CounterSection v-if="content && content.counterBlock" :content="content.counterBlock" />
      <VacanciesSection v-if="content && content.vacancies" :content="content.vacancies" />
    </div>
</template>

<script>
import { useHomeStore } from '@/stores/homeStore'
import HeroBlockSection from './HomePage//HeroBlockSection.vue';
import ServicesSection from './HomePage/ServicesSection.vue'
import AboutSection from './HomePage/AboutSection.vue'
import CounterSection from './HomePage/CounterSection.vue'
import VacanciesSection from './HomePage/VacanciesSection.vue'
import { watch } from 'vue'

export default {
  name: 'HomePageTemplate',
  components: {
    HeroBlockSection,
    ServicesSection,
    AboutSection,
    CounterSection,
    VacanciesSection
  },
  data() {
    return {
      content: null
    }
  },
  computed: {
    homeStore() {
      return useHomeStore()
    }
  },
  methods: {
    loadContent(locale) {
      this.homeStore.loadContent(locale).then(() => {
        this.content = { ...this.homeStore.content }
      })
    }
  },
  mounted() {
    const currentLocale = this.$i18n.locale
    this.loadContent(currentLocale)
    
    watch(
      () => this.$i18n.locale,
      (newLocale) => {
        this.loadContent(newLocale)
      }
    )
  }
}
</script>
